const $inject = [];

const noValueFilter = () => {
  return (input, char) => {
    return input || char;
  };
};

noValueFilter.$inject = $inject;

export default noValueFilter;



// WEBPACK FOOTER //
// ./src/filters/noValueFilter.js